import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '../../../_helpers/mixins';

import CountrySelector from '../../misc/CountrySelector';
import FormInput from '../../../blocks/FormInput';
import StatusText from '../../../elements/StatusText';
import { envelopePhoneSvg } from '../../../icons';

const WideIcon = styled(FormInput.Icon)`
  max-width: 67px;

  ${({ theme }) => media(theme.breakpoints.sm)`
    display: none;
  `};
`;

const WideIconInput = styled(FormInput.Input)`
  padding-left: 132px;

  ${({ theme }) => media(theme.breakpoints.sm)`
    padding-left: 50px;
  `};
`;

const CountrySelectorWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 78px;
  transform: translateY(-50%);

  ${({ theme }) => media(theme.breakpoints.sm)`
    left: 0;
  `};
`;

const EmailPhoneInput = ({
  error, onChange, onCountryChange, placeholder,
}) => (
  <>
    <FormInput>
      <WideIcon src={envelopePhoneSvg} />
      <CountrySelectorWrap>
        <CountrySelector _countrySelectHandler={onCountryChange} />
      </CountrySelectorWrap>
      <WideIconInput
        modifiers={[error ? 'error' : null]}
        onChange={onChange}
        placeholder={placeholder}
      />
    </FormInput>
    {error ? <StatusText modifiers={['error']}>{error}</StatusText> : null}
  </>
);

EmailPhoneInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  placeholder: PropTypes.string,
};

EmailPhoneInput.defaultProps = {
  error: '',
  placeholder: 'Email or phone number',
};

export default EmailPhoneInput;
